import { createRoot } from 'react-dom/client'
import { lazy, StrictMode, Suspense } from 'react'
import * as serviceWorker from './serviceWorker'
import { Flex, Loader } from '@mantine/core'

const Root = lazy(() =>
  import('@/app/providers').then((module) => ({
    default: module.Root
  }))
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense
      fallback={
        <Flex
          bg='#120F1D'
          top={0}
          left={0}
          pos='fixed'
          w='100vw'
          h='100vh'
          justify='center'
          align='center'
        >
          <Loader variant='dots' color='#9577F8' />
        </Flex>
      }
    >
      <Root />
    </Suspense>
  </StrictMode>
)

serviceWorker.unregister()
